import React, { useEffect, useState, useRef, Component,Router, props, useHistory } from "react";
import firebase from 'firebase/compat/app';
import "./loran.css"
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Creater.css"
import right from "../../Home/Home_modules/Im/right.png"
import "./more_nft.css"
import Fotter from '../../Home/Home_modules/Footerr/footer'
import './nftdetail.css'
import './popup.css';
import web3 from "web3";
import Modal from "./popup";
import firebaseConfig from '../../fire';
import 'react-coinbase-commerce/dist/coinbase-commerce-button.css';
import WalletConnect from "@walletconnect/client";
import QRCodeModal from "@walletconnect/qrcode-modal";
import Fortmatic from 'fortmatic';
import Web3 from 'web3';
import Top_selling_products from "../../Home/Home_modules/Top_selling_products";
import axios from "axios";
import { getAuth } from "firebase/auth";
import ShareButton from "react-web-share-button";
import { v4 as uuidv4 } from 'uuid';
import './res.css'
import avatar from './Im/useravatar.png'
import 'react-tabs/style/react-tabs.css';

require('dotenv').config()

var CryptoJS = require("crypto-js");

const divStyle = {
    borderColor: '#ffffff',
    backgroundColor:'#ffffff',
  };
  
toast.configure();
const likes = 100;
const btnDefault = {};
const bidfunction = () => {
  var alreadybidvalue = document.getElementById('previousbidvalue').value;
  var userbidvalue = document.getElementById('updated_value').value;
  if (alreadybidvalue >= userbidvalue ){
    toast.warning("Please Enter Value Greater than Previous Bid Value")
  }
  else {
    toast.success("Proceed to bid")
    localStorage.setItem('NewBidValue', userbidvalue);
    localStorage.setItem('updated_price', userbidvalue);
    const NewBidValue = localStorage.getItem('NewBidValue')
  }
}

const walletAddress = localStorage.getItem('LAST_ACTIVE_ACCOUNT');

export default class NftDetails extends React.Component{
  
  constructor(props) {
    super(props);
    this.handleAddOne = this.handleAddOne.bind(this);
    this.state = {
      count: 0,
      WlData:[],
      TxData: [],
      nftData: [],
      UserData: [],
      Username: [],
      purchaseHistory:[],
      bidHistory:[],
      biddata:[],
      nftprice : [],
      chainId : [],
      priceinusd: ''
    };
    this.handleLogin = this.handleLogin.bind(this);
  }
  
  handleLogin(){
    const currentUrl = window.location.pathname;
    localStorage.setItem('currentUrl', currentUrl);
    firebaseConfig.auth().onAuthStateChanged(function(user) {
      if(user) {
        //Here you can place the code that you want to run if the user is logged in
      } else {
        window.location.href = "../login";
      }
    })
  }
  
  modalOpen() {
    this.setState({ modal: true });
  }
  
  handleClose = () => {
    this.setState({ modal: false });
  }
  
  //wyre hosted function
  wyre = () =>{
    toast.success("processing your payment")
    const wyreurl = "https://api.sendwyre.com/v3/orders/reserve";
    const wyrekey = process.env.REACT_APP_WYRE_KEY;
    const wyresecret = process.env.REACT_APP_WYRE_SECRET;
    fetch(wyreurl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + wyresecret
      },
      body: JSON.stringify({
        "currency": "USD",
        "amount": this.state.nftData.price,
        "memo": "test",
        "referrerAccountId": "AC_3P9CE6432FG",
        "destCurrency": "ETH",
        "redirect": {
        "success": "https://diginoor.io/nftdetails/"+this.state.nftData.id,
        "failure": "https://diginoor.io/nftdetails/"+this.state.nftData.id,
      }})
    })
    .then(response => response.json())
    .then(data => {
      //console.log(data);
      const wyreredirect = data.url;
      window.open(wyreredirect, '_blank');
    })
    .catch(error => {
      //console.error(error)
    });
  }
  
  //cashfree payment
  cashfree = () =>{
    
    if (localStorage.getItem('LAST_ACTIVE_ACCOUNT') === null) {
      toast.warning("Please connect to wallet")
      window.location.href = "/wallet";
    }
    else {
      toast.success("processing your payment")
      const cashfreeurl = "https://cors-digi.herokuapp.com/https://sandbox.cashfree.com/pg/orders";
      const cashfreekey = process.env.REACT_APP_CASHFREE_KEY;
      const cashfreesecret = process.env.REACT_APP_CASHFREE_SECRET;
      const cashfreeorderid = uuidv4();
      const cashfreeamount = this.state.priceinusd * this.state.nftData.price;
      const cashfreeorderamount = cashfreeamount.toFixed(2);
      firebase.firestore().collection("checkout").add({
      order_id: cashfreeorderid,
      userId : firebase.auth().currentUser.uid,
      nftid : this.state.nftData.id,
      userEmail : firebase.auth().currentUser.email,
      date : new Date(),
      wallet: localStorage.getItem('LAST_ACTIVE_ACCOUNT'),
      nftid : localStorage.getItem('fileid'),
      paymentmethod: "cashfree",
    })
    .then(() => {
      //console.log("data added");
    }).catch(err => {
      //console.log(err);
    }
    )
    //console.log(cashfreeorderamount);
    const cashfreeorderdesc = "NFT Purchase";
    const cashfreeorderref = "NFT Purchase";
    var cashfreephone = "";
    this.state.UserData.phone === null ? cashfreephone = process.env.REACT_APP_CASHFREE_PHONE : cashfreephone = this.state.UserData.phone;
    const cashfreeorderurl = `https://diginoor.vercel.app/paymentstatus/${this.state.nftData.id}/{order_id}/{order_token}`;
    const cashfreeorderreq = {
      "order_id": cashfreeorderid,
      "order_amount": cashfreeorderamount,
      "order_currency": "INR",
      "order_note": cashfreeorderdesc,
      "customer_details": {
      "customer_id": this.state.UserData.uid,
      "customer_email": this.state.UserData.email,
      "customer_phone": cashfreephone,
    },
    "order_meta": {
      "return_url": cashfreeorderurl,
    }
    };
    fetch(cashfreeurl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + cashfreesecret,
        'Access-Control-Allow-Origin': '*',
        'x-api-version': '2022-01-01',
        'x-client-id': cashfreekey,
        'x-client-secret': cashfreesecret
      },
      body: JSON.stringify(cashfreeorderreq)
    })
    .then(response => response.json())
    .then(data => {
      //console.log(data);      
      const paymenttoken = data.order_token;
      const paymentlink = data.payment_link;
      //console.log(paymenttoken);
      //order payment
      window.location.href = paymentlink;
    })
    .catch(error => {
      //console.error(error)
    }
      );
  }
  }
  
  //fortmatic payment function
  fort = () =>{
    // storing data in firebase
    const db = firebase.firestore();
    const user = firebase.auth().currentUser;
    const userId = user.uid;
    const userEmail = user.email;
    db.collection('checkout').add({
      userId: userId,
      userEmail: userEmail,
      price: this.state.nftData.price,
      date: new Date(),
      wallet: localStorage.getItem('LAST_ACTIVE_ACCOUNT'),
      nftid : localStorage.getItem('fileid'),
      paymentmethod : 'Fortmatic',
    })
    .then(function(docRef) {
      //console.log("Document written with ID: ", docRef.id);
    })
    .catch(function(error) {
      //console.error("Error adding document: ", error);
    });
    const fm = new Fortmatic(process.env.REACT_APP_FORTMATIC);
    const Currencyvalue = localStorage.getItem('Currencyvalue')
    const web3 = new Web3(fm.getProvider());
    const toAddress = '0xb159752065EA68Ef0B22249Df25864E624fec45D';
    const sendValue = web3.utils.toWei("0.1", 'ether'); // Convert 1 ether to wei
    // Get user account wallet address first
    if (localStorage.getItem("LAST_ACTIVE_ACCOUNT") === null) {
      //alert("No Value")
      toast.error('Please Connect Wallet to Proceed');
      window.location.href ="../../../Wallet/";
    }
    else{
      web3.eth.getAccounts((error, accounts) => {
      if (error) throw error;
      // Construct Ether transaction params
      const txnParams = {
        from: accounts[0],
        to: toAddress,
        value: sendValue
      }
      // Send Ether transaction with web3
      web3.eth.sendTransaction(txnParams, (error, txnHash) => {
      if (error) throw error;
      //console.log(txnHash);
      toast.success("Transaction submitted to the blockchain, Please wait")
      const file_id = localStorage.getItem('fileid') //getting the particular value from the local storage
      const encrypted_file_id = CryptoJS.AES.encrypt(file_id, ''+process.env.REACT_APP_SECRET_KEY).toString().replace('+','xMl3Jk').replace('/','Por21Ld').replace('=','Ml32');     
                            //console.log(encrypted_file_id);    
                            window.location.href = "/confirmation/"+file_id+"/"+encrypted_file_id;
    });
   });}
  }
  
  wc = () =>{
    // storing data in firebase
    const db = firebase.firestore();
    const user = firebase.auth().currentUser;
    const userId = user.uid;
    const userEmail = user.email;
    db.collection('checkout').add({
      userId: userId,
      userEmail: userEmail,
      price: this.state.nftData.price,
      date: new Date(),
      wallet: localStorage.getItem('LAST_ACTIVE_ACCOUNT'),
      nftid : localStorage.getItem('fileid'),
      paymentmethod : 'Wallectconnect'
    })
    .then(function(docRef) {
      //console.log("Document written with ID: ", docRef.id);
    })
    .catch(function(error) {
      //console.error("Error adding document: ", error);
    });
    // Create a connector
    if (localStorage.getItem("LAST_ACTIVE_ACCOUNT") === null) {
      //alert("No Value")
      alert("Please Connect Wallet to Proceed");
      window.location.href ="../../../Wallet/";
    }
    else{
      const connector = new WalletConnect({
        bridge: "https://bridge.walletconnect.org", // Required
        qrcodeModal: QRCodeModal,
      });
      // Check if connection is already established
      if (!connector.connected) {
        // create new session
        connector.createSession();
        connector.on("connect", (error, payload) => {
          if (error) {
            throw error;
          }
          // Get provided accounts and chainId
          const { accounts, chainId } = payload.params[0];
          //console.log(accounts);
          localStorage.setItem('Fortmatic Address', accounts);
          toast.success("Please click again to pay")
        });  
      }
      else {

      }
      if (connector.connected){
        const Currencyvalue = localStorage.getItem('Currencyvalue')
        const Currency = Math.round(Currencyvalue * 100000) / 100000;
        const currency = Currency.toString();
        const wei = web3.utils.toWei(currency, 'ether')
        const Fortmatic_Address = localStorage.getItem('Fortmatic Address')
        const tx = {
          from: ""+Fortmatic_Address, // Required echo ()
          to: "0x9C26245C14276b6C83449517f95Ed939E24748AB", // Required (for non contract deployments)
          data: "0x", // Required
          gasPrice: "0x02540be400", // Optional
          gas: "0x9c40", // Optional
          value: ""+wei, // Optional
          nonce: "0x0114", // Optional
        };
        
        connector.sendTransaction(tx).then((result) => {
          // Returns transaction id (hash)
          toast.success("Transaction submitted to the blockchain, Please wait")
          //console.log(result);
          const file_id = localStorage.getItem('fileid') //getting the particular value from the local storage
          const encrypted_file_id = CryptoJS.AES.encrypt(file_id, ''+process.env.REACT_APP_SECRET_KEY).toString().replace('+','xMl3Jk').replace('/','Por21Ld').replace('=','Ml32');     
          //console.log(encrypted_file_id);    
          window.location.href = "/confirmation/"+file_id+"/"+encrypted_file_id;
        })
        .catch((error) => {
          // Error returned when rejected
          toast.error("Transaction Rejected")
          //console.error(error);
        });  
      }}
      // code finished
    }
    coin = () =>{
      if (localStorage.getItem("LAST_ACTIVE_ACCOUNT") === null) {
        //alert("No Value")
        alert("Please Connect Wallet to Proceed");
        window.location.href ="../../../Wallet/";
      }
      else{
        toast.success("Processing Payment");
        const file_id = localStorage.getItem('fileid')
        const encrypted_file_id = CryptoJS.AES.encrypt(file_id, ''+process.env.REACT_APP_SECRET_KEY).toString().replace('+','xMl3Jk').replace('/','Por21Ld').replace('=','Ml32');     
        fetch('https://api.commerce.coinbase.com/charges/', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CC-Api-Key': process.env.REACT_APP_COINBASE_API,
            'X-CC-Version': '2018-03-22'
          },
          body: JSON.stringify({
            "name": "Diginoor",
            "description": "India's First Cine NFT Marketplace",
            "local_price": {
            "amount": ""+this.state.nftData.price,
            "currency": "USD"
          },
          "pricing_type": "fixed_price",
          "redirect_url": "https://diginoor.io/confirmation/"+file_id+"/"+encrypted_file_id,
          "cancel_url": "https://diginoor.io/nftdetail/"+file_id,
        })
      }
      )
      .then(response => response.json())
      .then(data => {
        //console.log(data)
        localStorage.setItem('coinbase_url', data.data.hosted_url)
        //console.log(data.data.hosted_url)
        window.location.href = data.data.hosted_url
      })
    }
  }
  
  componentDidMount() {
    const stringCount = localStorage.getItem("count");
    const count = parseInt(stringCount, 10);
    if (!isNaN(count)) {
      this.setState(() => ({ count }));
    }
  }
    
    componentDidUpdate(prevProps, prevState) {
      if (prevState.count !== this.state.count) {
        localStorage.setItem("count", this.state.count);
      }
      const nftId = this.props.match.params.nftid;
      const nftRef = firebase.firestore().collection("NFTs").doc(nftId);
      nftRef.get().then((doc) => {
        if (!doc.exists) return;
        // setNFTData(doc.data());
        //console.log("Individual NFT data:", doc.data());
        this.setState({nftData: doc.data()});
        //console.log(doc.data().price)
        //console.log(doc.data().price)
        //this.setState({usdvalue: price});
        //console.log(this.state.nftData);
        //alert(this.state.properties.category);
        const id = ""+this.state.nftData.id
        localStorage.setItem('fileid', id);
        localStorage.setItem('NFT Price', this.state.nftData.price);
      });
      
      }

      handleAddOne() {
        this.setState(prevState => {
          return {
            count: prevState.count + 1
          };
        });
      }
      
      componentWillMount() {
        
        //check login status
        firebase.auth().onAuthStateChanged(user => {
          if (user) {
        const userData = firebase.firestore().collection('users')
        .where('uid', '==', getAuth().currentUser.uid).get({ source: 'server' }).then(res => {
        if (res.docs.length  == 1) {
          //console.log('user details here', res.docs[0].data())
          //  this.setState({userdata: res.docs[0].data()});
          // console.log("User data Fetch:",this.state.userdata);
          //console.log(this.state.userdata.value);
          //console.log(res.docs[0].data())
          this.setState({UserData: res.docs[0].data()});
          //console.log(this.state.UserData.phone)
        } 
        })
        .catch(err => {
          //console.log('Something went wrong in user details API', err)
        })
      }else{
        toast.success("Please Login for better experience")
        //console.log("User is not logged in");
      }
      });
        const nftId = this.props.match.params.nftid;
        const purchaseHistoryUrl = `https://us-central1-diginoor-3755e.cloudfunctions.net/app/purchases?nft_id=${nftId}`;
        fetch(purchaseHistoryUrl,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*',
            }   
          })
          .then(res => res.json())
          .then(data => {
            //console.log(data.nft_purchases);
            this.setState({purchaseHistory: data.nft_purchases})
          })
          .catch(err => console.log(err))
          //console.log(nftId)
          const nftRef = firebase.firestore().collection("NFTs").doc(nftId);
          nftRef.get().then((doc) => {
            if (!doc.exists) return;
            // setNFTData(doc.data());
            //console.log("Individual NFT data:", doc.data());
            this.setState({nftData: doc.data()});
            //console.log(doc.data().price)
            //console.log(doc.data().price)
            //this.setState({usdvalue: price});
            //console.log(this.state.nftData);
            //alert(this.state.properties.category);
            const id = ""+this.state.nftData.id
            localStorage.setItem('fileid', id);
            localStorage.setItem('NFT Price', this.state.nftData.price);
          });
          // Get the Latest bid value from firebase
          const bidinfo = firebase.firestore().collection("bids").where("nft", "==", nftId)
          .orderBy("value", "desc").limit(1);
          bidinfo.get({source: "server"})
          .then(res => {
            if (res.docs.length  == 1) {
              //console.log('Bid Details', res.docs[0].data())
              this.setState({biddata: res.docs[0].data()});
              //console.log(this.state.biddata);
              //console.log(this.state.biddata.value);
              localStorage.setItem('Latest Bid Value', this.state.biddata.value);
              // alert(this.state.biddata.value);
            }
          });
          
          // code finished
          //sale history
          const bidinf = firebase.firestore().collection("bids").where("nftId", "==", nftId)
          .orderBy("timestamp", "desc").limit(1);
          bidinfo.get({source: "server"})
          .then(res => {
            if (res.docs.length  == 1) {
              //console.log('Sale History', res.docs[0].data())
              this.setState({biddata: res.docs[0].data()});
              //console.log(this.state.biddata);
              //console.log(this.state.biddata.value);
              localStorage.setItem('Latest Bid Value', this.state.biddata.value);
              //alert(this.state.biddata.value);
            }else{
              //alert("Error..!")
            }
          });
          //end code
          // Bid Histroy API

          const bidHistoryUrl = `https://cors-digi.herokuapp.com/https://us-central1-diginoor-3755e.cloudfunctions.net/app/bid/latest`;
          const bidData = new Array();
          fetch(bidHistoryUrl,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Access-Control-Allow-Origin': '*',
              },
              body: JSON.stringify({
                nft: nftId
              })
            })
            .then(res => res.json())
            .then(data => {
              
              this.setState({bidHistory: data.response})
              //console.log(this.state.bidHistory);
            })
            .catch(err => console.log(err))
            //console.log(nftId)
            

          // Latest NFT price
          const nftPrice = firebase.firestore().collection("NFTs").doc(nftId);
          nftPrice.get().then((doc) => {
            if (!doc.exists) return;

            this.setState({nftprice: doc.data().matic});
            //alert(this.state.nftData.auctionid);
          });
            


          const apiUrl = `https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=USD&api_key=${process.env.REACT_APP_CRYPTOCOMPARE}`;
          fetch(apiUrl)
          .then(res => res.json())
          .then(
            (result) => {
              //console.log(result);
              this.setState({Username: result});
             // console.log("ETH",this.state.Username);
            }
            )
            
            // Currency Conversion
            fetch('https://api.exchangerate.host/latest?base=USD')
            .then(res => res.json())
            .then(data => {
              //console.log(data);
              this.setState({priceinusd: data.rates.INR});
            })
                      


                      }
                      
  render(){
    var num1 = "1";
    var num2 = ""+this.state.Username.USD;
    var num3 = ""+this.state.nftData.price;
    var answer = num1 / num2 * num3;    
    //console.log("Price",this.state.Username.USD);     
    localStorage.setItem('Currencyvalue', answer);
    //console.log(this.state.nftData)
    const latestbidvalue = localStorage.getItem("Latest Bid Value");
    const BidTxId = localStorage.getItem("BidTxId");
    const BidValue = localStorage.getItem("BidValue");
    const uname = localStorage.getItem("UserData");
    const totalPrice = 58;

    if (this.state.nftData.auction == "Yes"){
      return(
      <>
      <div className="container-fluid">
        <div className="row" >
          <div className="nft-final-video">
            <center> 
              { this.state.nftData.celebrity === 'vivek' ?
              <img src={this.state.nftData.nft_image} className='nft-image' alt="nft-video" />
                 : <iframe src={this.state.nftData.nft_media_url}
                 className="nft-video" frameBorder="0"
                 allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
         allowFullScreen></iframe>
       }
            </center>
            <div className="vdo-btnn-full">
              <button  className="vdo-btnn" onClick={this.handleAddOne}>
                <span className="glyphicon glyphicon-heart-empty"></span> Like {this.state.count}
              </button>
              <button  className="vdo-btnn2">
                <span className="glyphicon glyphicon-share"></span> 
                <ShareButton buttonStyle={divStyle}/> 
              </button>
            </div>
          </div>            
        </div>
      </div>
      <div className="Loran-title-full">
        <Modal show={this.state.modal}>
          <h2>Place a bid <a href="#" onClick={this.handleClose} className="closebutton">&#10006;</a></h2>  
          <p>You're about to buy {this.state.nftData.nft_title} by {this.state.nftData.creators}</p>
          <h3>Price</h3>
          <div className="bid-value-section">
            <div className="bid-value">
              <span>{this.state.nftprice}
              <input type="hidden" id="previousbidvalue" value={this.state.nftprice}></input>
              </span>
            </div>
            <div className="bid-currency">
              <span>MATIC</span>
            </div>
          </div>
          <hr />
          {/* <h4 className="place-a-bid-notice">Must be at least 4.50 ETH</h4> */}
          <div className="bidding-details">
            <div>
              <p>Your bid price</p>
              <p>Gas fee</p>
            </div>
            <div>
              <p><input type="number" id="updated_value" onChange={bidfunction} className="form-control" placeholder="Bid Value" style={{color: 'white',backgroundColor: '#000000'}}></input></p>
              <p>AUTO</p>
            </div>
          </div>
          <div className="buttoncenter">
            
              <button
              style={{top: '0px',right: '0px'}}
              className="bbn632-hover bn28" 
               onClick={async () => {
                 if (localStorage.getItem("LAST_ACTIVE_ACCOUNT") === null) {
                   //alert("No Value")
                   alert('Please Connect Wallet to Proceed');
                   window.location.href ="../../../Wallet/";
                  }
                else{
                  localStorage.setItem('NFTBidId', this.state.nftData.id);
                  const updatedprice = document.getElementById("updated_value").value;
                  localStorage.setItem('Bidvalue', updatedprice); 
                  const response = await axios.post('https://api-eu1.tatum.io/v3/blockchain/auction/bid', {
                    "chain": "MATIC",
                    "contractAddress": "0x8d6EA8C4ECf86ea4bD46d8d6f8c5966B1c21152E",
                    "id": ""+this.state.nftData.auctionid,
                    "bidValue": ""+updatedprice,
                    "signatureId": process.env.REACT_APP_TATUM_SIGNID,
                  }, {
                    headers: {
                      'x-api-key': process.env.REACT_APP_TATUM_API_KEY,
                    }
                  });
                  //console.log(response);
                  toast.success('Processing Bid, Please wait');
                  const {
                    signatureId
                  } = response.data;
                  //alert(signatureId);
                  const {data} = await axios.get('https://api-eu1.tatum.io/v3/kms/' + signatureId, {
                    headers: {
                      'x-api-key': process.env.REACT_APP_TATUM_API_KEY
                    }
                  });
                  
                  const txConfig = JSON.parse(data.serializedTransaction);
                  //console.log(txConfig);
                  toast.success('Please do not refresh the page');
                  try {
                    const web3 = new Web3(window.ethereum);
                    const accounts = await web3.eth.getAccounts();
                    const ethereum = window.ethereum;
                    await ethereum.request({ method: "eth_requestAccounts" });
                    const chainId = await ethereum.request({ method: "eth_chainId" });
                    txConfig.from = accounts[0];
                    txConfig.gasPrice = "200000000";
                    try {
                      // check chainId
                      const { ethereum } = window;
                    if (chainId === "0x89") {
                      //alert("transaction starting")
                      const result = await window.ethereum.request({
                        method: "eth_sendTransaction",
                        params: [txConfig],
                      });
                      //console.log(result);
                      // wait for confirmation
                      const receipt = await new Promise((resolve, reject) => {
                        const interval = setInterval(async () => {
                          const receipt = await ethereum.request({
                            method: "eth_getTransactionReceipt",
                            params: [result],
                          });
                          if (receipt) {
                            clearInterval(interval);
                            resolve(receipt);
                          }
                        }, 1000);
                      });
                      //console.log(receipt);
                      toast.success('Bid Placed Successfully');
                      //alert("Bid Placed Successfully");
                      localStorage.setItem('TransactionId', result);
                      const file_id = localStorage.getItem('fileid')
                      window.location.href ="../../../Bid_conformation/"+ file_id;
                    }
                    else{
                      toast.error('Please Connect to Matic Mainnet to Bid');                    
                    } 
                    } catch (error) {
                      toast.error("Payment Failed");
                    }
                  }
                  catch (error) {
                    //console.log(error);
                  }
                }} }>Metamask</button>

                <center>Or</center>
                <button
              style={{top: '0px',right: '0px'}}
              className="bbn632-hover bn28" 
               onClick={async () => {
                 if (localStorage.getItem("LAST_ACTIVE_ACCOUNT") === null) {
                   //alert("No Value")
                   alert('Please Connect Wallet to Proceed');
                   window.location.href ="../../../Wallet/";
                  }
                else{
                  localStorage.setItem('NFTBidId', this.state.nftData.id);
                  const updatedprice = document.getElementById("updated_value").value;
                  localStorage.setItem('Bidvalue', updatedprice); 
                  const response = await axios.post('https://api-eu1.tatum.io/v3/blockchain/auction/bid', {
                    "chain": "MATIC",
                    "contractAddress": "0x8d6EA8C4ECf86ea4bD46d8d6f8c5966B1c21152E",
                    "id": ""+this.state.nftData.auctionid,
                    "bidValue": ""+updatedprice,
                    "signatureId": process.env.REACT_APP_TATUM_SIGNID,
                  }, {
                    headers: {
                      'x-api-key': process.env.REACT_APP_TATUM_API_KEY
                    }
                  });
                  //console.log(response);
                  toast.success('Processing Bid, Please wait');
                  const {
                    signatureId
                  } = response.data;
                  const {data} = await axios.get('https://api-eu1.tatum.io/v3/kms/' + signatureId, {
                    headers: {
                      'x-api-key': process.env.REACT_APP_TATUM_API_KEY
                    }
                  });
                  const txConfig = JSON.parse(data.serializedTransaction);
                  //console.log(txConfig);
                  toast.success('Please do not refresh the page');
                  const connector = new WalletConnect({
                    bridge: "https://bridge.walletconnect.org", // Required
                    qrcodeModal: QRCodeModal,
                    });
                    
                    // create session
                    if (!connector.connected) {
                      // create session
                      connector.createSession();
                      connector.on("connect", (error, payload) => {
                        if (error) {
                          throw error;
                        }
                        // Get provided accounts and chainId
                        const { accounts, chainId } = payload.params[0];
                        this.setState({ chainId: chainId });
                        const account = accounts[0];
                          localStorage.setItem('wc_account',account);
                          toast.success("Please click again to pay")
                      });
                    }
                    
                    else if (this.state.chainId === "0x89") {
                      txConfig.from = walletAddress;
                      txConfig.gasPrice = "200000000";
                      
                      
                          try {
                            // check chainId
                            const { ethereum } = window;
                            const result = await connector.sendTransaction(txConfig);
                            // wait for confirmation
                            const receipt = await new Promise((resolve, reject) => {
                              const interval = setInterval(async () => {
                                const receipt = await ethereum.request({
                                  method: "eth_getTransactionReceipt",
                                  params: [result],
                                });
                                if (receipt) {
                                  clearInterval(interval);
                                  resolve(receipt);
                                }
                              }, 1000);
                            });
                            //console.log(receipt);
                            toast.success('Bid Placed Successfully');
                            //alert("Bid Placed Successfully");
                            localStorage.setItem('TransactionId', result);
                            const file_id = localStorage.getItem('fileid')
                            window.location.href ="../../../Bid_conformation/"+ file_id;
                          } catch (error) {
                            toast.error("Payment Failed");
                          }
                    }
                    else{
                      toast.error('Please Connect to Matic Mainnet to Bid');
                    }
                }} }>Wallet Connect</button>
                <br></br>
                <center>
                  <p>Make sure you're connected to <b>MATIC MAINNET</b> before placing bid to prevent loss of funds</p>
                </center>
              </div>
              </Modal >
              <div className="">
                <div className="set-1">
                  <div className="loran-left">
                    <h1 className="loran-ti">{this.state.nftData.nft_title}</h1>
                      <button className="rounded-pill" id="legentry">{this.state.nftData.collection}</button>
                      <br></br>
                      <br></br>
                      <h2 className="disc">DESCRIPTION</h2>
                      <div className="lorem-para">
                        <p>{this.state.nftData.description}</p>
                      </div>
                  </div>
                </div>
                <div className="set-1">
                  <div className="loran-right">                       
                      <div className="tabb-box">
                          <div className="current-bid">
                            <div className="current-bid-text-1">
                              <h3 className="current-bid-text-heading">Last Bid Value</h3>
                              <h1 className="current-bid-price">{this.state.nftData.matic} MAT</h1>
                              <h5 className="current-bid-price-small">${this.state.nftData.price} Reserved Price</h5>
                            </div>
                          </div>
                          <div className="final-verti-line"></div>
                            <div>
                              <div className="current-bid2">
                                <div className="current-bid-text-1">
                                  <h3  className="current-bid-text-heading">Auction ending in</h3>
                                  <h1   className="current-bid-price">
                                    --</h1>
                                  <h5 className="date-time">  Days     Hours      Mins  Secs</h5>
                                </div>
                              </div>
                            </div>
                              <hr className="final-box-hr"></hr>
                              <button className="bbn632-hover bn28"
                                 id="place-a-bid"
                                  onClick={this.state.nftData.celebrity == 'vivek' ? null : null}>
                                   {this.state.nftData.celebrity == 'vivek' ? 'Auction Ended' : 'Auction Ended' }</button>       
                              </div> 
                              <div className="purchase-box">
                                <div>
                                  <h3 className="current-bid-text-heading">Last Bid Value</h3>
                                  <h1 className="current-bid-price">{this.state.nftData.matic} MAT</h1>
                                  <h5 className="current-bid-price-small">${this.state.nftData.price} Reserved Price</h5>
                                </div>
                                <div>
                                  <h3  className="current-bid-text-heading">Auction ends in</h3>
                                  <h1   className="current-bid-price">
                                    --</h1>
                                  <h5 className="date-time">  Days      Hours      Mins  Secs</h5>
                                </div>
                                <div>
                                  <button className="bbn632-hover bn28"
                                     id="place-a-bid" onClick={this.state.nftData.celebrity == 'vivek' ? null : null}>
                                       {this.state.nftData.celebrity == 'vivek' ? 'Auction Ended' : 'Auction Ended' }</button>
                                </div>
                              </div>                        
      
                              <div className="exclusive">
                                <div className="rewards-dropdown">
                                  <button className="exclusive-bt">EXCLUSIVE REWARDS AVAILABLE
                                    <span class="glyphicon glyphicon-menu-down"
                                     aria-hidden="true" id="drop-down"></span>
                                  </button>
                                  <div className="dropdown-content" style={{'borderRadius':'50px'}}>
                                    <center> 
                                      <h4 style={{ color: 'white' }}>{this.state.nftData.exclusive}</h4>
                                    </center>
                                  </div>
                                </div>  
                              </div>
                  </div>
                </div>
              </div>
              <br></br>
              <br></br><br></br>
              <br></br>
              <br></br><br></br>
              
              {/* DETAILS */}
              
              <div className="final-details">
                <div>
                  <p className="disc">DETAILS</p>
                  <div className="final-boxx">
                    <p
                     className="ctnt">{this.state.nftData.available}
                      of {this.state.nftData.quantity} NFTs remaining</p>
                  </div>
                  <br></br>
                  <div className="final-boxx">
                    <p className="ctnt1">Blockchain <span className="content-shad">Polygon</span> </p>
                  </div>
                </div>
                <div className="final-properties-full" >
                  <div className="final-properties">
                    <p className="final-properties-head">PROPERTIES</p>
                  </div>
                  <div></div>
                  <div className="final-properties-boxx">
                    <div className="final-properties-box">
                      <p className="final-properties-box-text">Category</p>
                      <p className="final-properties-box-text1">{this.state.nftData.category}</p>
                    </div>
                    <div className="final-properties-box">
                      <p className="final-properties-box-text-framerate">Movie</p>
                      <p style={this.state.nftData.celebrity == 'vivek' ? {fontSize:'15px'} : null }
                      className="final-properties-box-text1-24">{this.state.nftData.movie}</p>
                    </div>
                    <div className="final-properties-box">
                      <p className="final-properties-box-text-framerate"> Celebrity</p>
                      <p className="final-properties-box-text1-24">{this.state.nftData.celebrity}</p>
                    </div>
                    <div className="final-properties-box">
                      <p className="final-properties-box-text-framerate">Production</p>
                      <p className="final-properties-box-text1-purple">{this.state.nftData.production_house}</p>
                    </div>
                    <div className="final-properties-box">
                      <p className="final-properties-box-text">Rarity</p>
                      <p className="final-properties-box-text1">{this.state.nftData.rarity}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="creater-pg-full">
              <div className="creaters">
                <h1 className="creaters-heading">CREATOR</h1>
                  <img className="o-p-img" src={this.state.nftData.seller} alt="Logo" />
                  <img className="o-right" src={right} alt="Logo" />
                  <h2 className="creater-avm">{this.state.nftData.creators}</h2>
                  <p className="creater-royalty">10% Royalties</p>
              </div>
              <div className="final-collection">
                <h1 className="creaters-heading">COLLECTION</h1>
                <img className="o-p-img" src={this.state.nftData.film_image} alt="Logo" />
                <img className="o-right" src={right} alt="Logo" />
                <h2 className="creater-avm">{this.state.nftData.film_name}</h2>
                <p className="creater-royalty">{this.state.nftData.rarity}</p>
              </div>
              <div className="final-view-prof">
                <a href="https://polygonscan.com/address/0x5421b3bcce730885d9f0869e840b67904daa0c97#tokentxnsErc721"
                 target="_blank">
                   <p className="final-view-prof-text">VIEW PROOF OF AUTHENTICITY
                    <span className="glyphicon glyphicon-edit"></span></p>
                </a>
              </div>
              <div className="final-about-avm">
                <p className="final-about-avm-head">ABOUT CREATORS</p>
              <div >
                <p className="final-about-avm-para">{this.state.nftData.about}</p>
              </div>
              </div>
              
              <div className="final-sales-history">
              <div  class="switch-button" >
                <input   class="switch-button-checkbox" type="checkbox"></input>
                <label class="switch-button-label"
                 for=""><span class="switch-button-label-span" id="bid-text">Bid history</span>
                </label>
              </div>
              <div>
                {this.state.bidHistory && this.state.bidHistory.map((item) =>{
                  return(
                  <div className="final-sales-box" >{item.tx}
                  <div>
                    <img src={avatar} className="final-sale-img" />
                  </div>
                  <div className="final-sales-username-content" style={{maxHeight:'100px'}}>
                    <p className="final-about-avm-head"></p>
                    <div className="history-hash">
                      <a href={` https://polygonscan.com/tx/${item.TxId}`} target="_blank">{item.TxId}</a>
                    </div>
                    <div className="final-sales-username-content2">
                      <p className="final-about-avm-head">{item.value} MAT</p>
                    </div>
                  </div>
                </div>
              )
            })}
            
            </div>
          </div>
          </div>
          <div>
            <div className="final-more-nft-full">
              <h1 className="thead">MORE NFTS YOU MIGHT LIKE</h1>
              <Top_selling_products />
            </div>
          </div>
          <Fotter/>
            </>
            );
          }
          else{
            const { product } = this.state;
            let amount, description, label;
            if (product === "nft") {
              amount = ""+this.state.nftData.price;
              description = "Buy NFT for $" + amount;
              label = "Buy for $" + amount;
            }
            
            return(
            <>
            <div className="container-fluid">
              <div className="row" >
                <div className="nft-final-video">
                  <center> 
                  { this.state.nftData.celebrity === 'vivek' ?
                  <img src={this.state.nftData.nft_image} className='nft-image' alt="nft-video" />
                  : <iframe src={this.state.nftData.nft_media_url}
                  className="nft-video" frameBorder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen></iframe>
                  }             
                  </center>
                  <div className="vdo-btnn-full">
                    <button  className="vdo-btnn" onClick={this.handleAddOne}>
                      <span className="glyphicon glyphicon-heart-empty"></span> Like {this.state.count}
                    </button>
                    <button  className="vdo-btnn2">
                      <span className="glyphicon glyphicon-share"></span> 
                      <ShareButton buttonStyle={divStyle}/> </button>
                  </div>
                </div>
              <div>
            </div>
          </div>
        </div>
        <div className="Loran-title-full">
          <Modal show={this.state.modal}>
            <h2>Purchase <a href="#" onClick={this.handleClose} className="closebutton">&#10006;</a></h2>  
            <p>You're about to buy {this.state.nftData.nft_title} by {this.state.nftData.production_house}</p>
            <h3>Price</h3>
            <div className="bid-value-section">
              <div className="bid-value">
                <span>{answer}</span>
              </div>
              <div className="bid-currency">
                <span>ETH</span>
              </div>
            </div>
            <hr />
            <div className="bidding-details">
              <div>
                <p>Gas fee</p>
                <p>You will pay</p>
              </div>
              <div>
                <p>Calculated on transaction</p>
              </div>
            </div>
            <div style={{marginTop:'-20px'}} className="buttonsection">
              <div onClick={this.handleLogin}>
                <div class="button1">
                <div className="wallet-selector-dropdown">
                  <span style={{fontSize:'14px'}}>Buy Using Wallet</span>
                    <div className="wallet-selector-dropdown-content">
                      <p onClick={this.wc} className="wallet-select-item">Wallet Connect</p> 
                      <p onClick ={async () => {
                      // storing data in firebase
                      const db = firebase.firestore();
                      const user = firebase.auth().currentUser;
                      const userId = user.uid;
                      const userEmail = user.email;
                      db.collection('checkout').add({
                        userId: userId,
                        userEmail: userEmail,
                        price: this.state.nftData.price,
                        date: new Date(),
                        wallet: localStorage.getItem('LAST_ACTIVE_ACCOUNT'),
                        nftid : localStorage.getItem('fileid'),
                        paymentmethod : 'MetaMask'
                      })
                      .then(function(docRef) {
                        //console.log("Document written with ID: ", docRef.id);
                      })
                      .catch(function(error) {
                        //console.error("Error adding document: ", error);
                      });
                      if (localStorage.getItem("LAST_ACTIVE_ACCOUNT") === null) {
                        //alert("No Value")
                        toast.error('Please Connect Wallet to Proceed');
                        window.location.href ="../../../Wallet/";
                      }
                      else{
                        const { ethereum } = window;
                        await ethereum.request({ method: "eth_requestAccounts" });
                        const accounts = await ethereum.request({ method: "eth_accounts" });
                        const account = accounts[0];
                        const chainId = await ethereum.request({ method: "eth_chainId" });
                        const Currencyvalue = localStorage.getItem('Currencyvalue') 
                        const Currency = Math.round(Currencyvalue * 100000) / 100000;
                        const currency = Currency.toString();
                        const wei = web3.utils.toWei(currency, 'ether')
                        const gasprice = await ethereum.request({ method: "eth_gasPrice" });
                        if (chainId !== "0x1") {
                          const params = [
                            {
                              from: account,
                              to: "0x9C26245C14276b6C83449517f95Ed939E24748AB",
                              gasPrice: gasprice, 
                              value: web3.utils.toHex(wei),
                            }
                          ];
                          
                          try {
                            const result = await window.ethereum.request({
                              method: "eth_sendTransaction",
                              params
                            });
                            //console.log(result);
                            const file_id = localStorage.getItem('fileid')
                            /* encrypting the file id */
                            //console.log(file_id);
                            const encrypted_file_id = CryptoJS.AES.encrypt(file_id, ''+process.env.REACT_APP_SECRET_KEY).toString().replace('+','xMl3Jk').replace('/','Por21Ld').replace('=','Ml32');     
                            //console.log(encrypted_file_id);    
                            window.location.href = "/confirmation/"+file_id+"/"+encrypted_file_id;
                          } catch (error) {
                            toast.error("Payment Failed");
                          }
                        }
                        else {
                          toast.error("Please Connect to Mainnet");
                        }
                        }}} className="wallet-select-item">Metamask</p>
                        <p onClick={this.fort} className="wallet-select-item">Fortmatic</p>
                    </div>
                </div>
                </div>
                </div>
                <div onClick={this.handleLogin}>
                  <div class="button2">
                    <div className="wallet-selector-dropdown">
                      <span style={{fontSize:'14px'}}>Buy Crypto / Card</span>
                        <div className="wallet-selector-dropdown-content">
                          <p onClick={this.wyre} className="wallet-select-item">Add funds/crypto</p> 
                          <p onClick={this.cashfree} className="wallet-select-item">Pay using Wallet / UPI</p>
                          <p onClick={this.coin} className="wallet-select-item">Coinbase</p>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
          </Modal >
          
          <div className="">
            <div className="set-1">
              <div className="loran-left">
                <h1 className="loran-ti">{this.state.nftData.nft_title}</h1>
                  <button className="rounded-pill" id="legentry">{this.state.nftData.collection}</button>
                  <br></br>
                  <br></br>
                  <h2 className="disc">DESCRIPTION</h2>
                  <div className="lorem-para">
                    <p>{this.state.nftData.description}</p>
                  </div>
              </div>
            </div>
            <div className="set-1">
              <div className="loran-right">                       
                <div className="tabb-box">
                  <div className="current-bid">
                    <div className="current-bid-text-1">
                      <h3 className="current-bid-text-heading">Fixed Price</h3>
                      <h1 className="current-bid-price">${this.state.nftData.price}</h1>
                      <h5 className="current-bid-price-small">{answer} ETH</h5>
                    </div>
                  </div>
                  <div className="final-verti-line"></div>
                    <div>
                      <div className="current-bid2">
                        <div className="current-bid-text-1">
                          <h3  className="current-bid-text-heading">Auction ending in</h3>
                          <h1   className="current-bid-price">- : - : -</h1>
                          <h5 className="date-time">  days      hours      minutes</h5>
                        </div>
                      </div>
                    </div>
                    <hr className="final-box-hr"></hr>
                    <button className="bbn632-hover bn28"
                       id="place-a-bid" onClick={e => this.modalOpen(e)}>PURCHASE
                    </button>       
                  </div> 
                  <div className="purchase-box">
                    <div>
                      <h3 className="current-bid-text-heading">Fixed Price</h3>
                      <h1 className="current-bid-price">${this.state.nftData.price}</h1>
                      <h5 className="current-bid-price-small">{answer} ETH</h5>
                    </div>
                    <div>
                      <h3  className="current-bid-text-heading">Auction ending in</h3>
                      <h1   className="current-bid-price">- : - : -</h1>
                      <h5 className="date-time">  days      hours      minutes</h5>
                    </div>
                    <div>
                      <button className="bbn632-hover bn28"
                         id="place-a-bid" onClick={e => this.modalOpen(e)}>PURCHASE</button>
                    </div>
                  </div>                        
                  
                  <div className="exclusive">
                    <div className="dropdown">
                      <button className="exclusive-bt">EXCLUSIVE REWARDS AVAILABLE
                        <span class="glyphicon glyphicon-menu-down"
                         aria-hidden="true" id="drop-down"></span> 
                      </button>
                      <div className="dropdown-content" style={{'borderRadius':'50px'}}>
                        <center> 
                          <h4 style={{ color: 'white' }}>{this.state.nftData.exclusive}</h4>
                        </center>
                      </div>
                    </div>  
                  </div>
                </div>
              </div>
            </div>
            <br></br>
            <br></br><br></br>
            <br></br>
            <br></br><br></br>
  
            {/* DETAILS */}
            
            <div className="final-details">
              <div>
                <p className="disc">DETAILS</p>
                <div className="final-boxx">
                  <p className="ctnt">{this.state.nftData.available} of {this.state.nftData.quantity} NFTs remaining</p>
                </div>
                <br></br>
                <div className="final-boxx">
                  <p className="ctnt1">Blockchain
                   <span className="content-shad">Polygon</span>
                  </p>
                </div>
              </div>
              {/* properties */}
              <div className="final-properties-full" >
                <div className="final-properties">
                  <p className="final-properties-head">PROPERTIES</p>
                </div>
                <div></div>
                <div className="final-properties-boxx">
                  <div className="final-properties-box">
                    <p className="final-properties-box-text">Category</p>
                    <p className="final-properties-box-text1">{this.state.nftData.category}</p>
                  </div>
                  <div className="final-properties-box">
                    <p className="final-properties-box-text-framerate">Movie</p>
                    <p className="final-properties-box-text1-24">{this.state.nftData.movie}</p>
                  </div>
                  <div className="final-properties-box">
                    <p className="final-properties-box-text-framerate">Celebrity</p>
                    <p className="final-properties-box-text1-24">{this.state.nftData.celebrity}</p>
                  </div>
                  <div className="final-properties-box">
                    <p className="final-properties-box-text-framerate">Production</p>
                    <p className="final-properties-box-text1-purple">{this.state.nftData.production_house}</p>
                  </div>
                  <div className="final-properties-box">
                    <p className="final-properties-box-text">Rarity</p>
                    <p className="final-properties-box-text1">{this.state.nftData.rarity}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
  
          <div className="creater-pg-full">
            <div className="creaters">
              <h1 className="creaters-heading">CREATOR</h1>
              <img className="o-p-img" src={this.state.nftData.seller} alt="Logo" />
              <img className="o-right" src={right} alt="Logo" />
              <h2 className="creater-avm">{this.state.nftData.celebrity = 'vivek' ? this.state.nftData.creators : this.state.nftData.production_house}</h2>
              <p className="creater-royalty">10% Royalties</p>
            </div>
            <div className="final-collection">
              <h1 className="creaters-heading">COLLECTION</h1>
              <img className="o-p-img" src={this.state.nftData.film_image} alt="Logo" />
              <img className="o-right" src={right} alt="Logo" />
              <h2 className="creater-avm">{this.state.nftData.film_name}</h2>
              <p className="creater-royalty">{this.state.nftData.collection}</p>
            </div>
            
            <div className="final-view-prof">
              <a href="https://polygonscan.com/address/0x79cbed473efa0e8ca16bf0da99c06d037fc5c65c" target="_blank">
                <p className="final-view-prof-text">VIEW PROOF OF AUTHENTICITY 
                <span className="glyphicon glyphicon-edit"></span></p>
              </a>
            </div>
            
            <div className="final-about-avm">
              <p className="final-about-avm-head">ABOUT {this.state.nftData.celebrity = 'vivek' ? this.state.nftData.creators : this.state.nftData.production_house}</p>
              <div >
                <p className="final-about-avm-para">{this.state.nftData.about}</p>
              </div>
            </div>
            <div className="final-sales-history">
              <div  class="switch-button" >
                <input   class="switch-button-checkbox" type="checkbox"></input>
                <label class="switch-button-label"
                 for=""><span class="switch-button-label-span" id="bid-text">Sale history</span>
                </label>
              </div>
              <div>
                {this.state.purchaseHistory && this.state.purchaseHistory.map((item) =>{
                  return(
                  <div className="final-sales-box" >{item.tx}
                  <div>
                    <img src={avatar} className="final-sale-img" />
                  </div>
                  <div className="final-sales-username-content" style={{maxHeight:'100px'}}>
                    <p className="final-about-avm-head"></p>
                    <div className="history-hash">
                      <a href={` https://polygonscan.com/tx/${item.txnid}`} target="_blank">{item.txnid}</a>
                    </div>
                    <div className="final-sales-username-content2">
                      <p className="final-about-avm-head">{item.nft.price} USD</p>
                    </div>
                  </div>
                </div>
              )
            })}
            
            </div>
          </div>
        </div>
        <div>
          <div className="final-more-nft-full">
            <h1 className="thead">MORE NFTS YOU MIGHT LIKE</h1>
              <Top_selling_products />
          </div>
        </div>
        <Fotter/>
        </>
        );
      }
    }
  }
  
export function onToken(token) {
  if (localStorage.getItem("LAST_ACTIVE_ACCOUNT") === null) {
    //alert("No Value")
    toast.error('Please Connect Wallet to Proceed');
    window.location.href ="../../../Wallet/";
  }
  else{
    // alert("yes value");
    const file_id = localStorage.getItem('fileid')
    toast.success('Payment Successful');
    window.location.href ="../../../confirmation/"+ file_id;
  }
}